export const VIEW_MODES = {
  simple: 'Simple',
  detailed: 'Detailed',
}
